<template>
    <multiplier
        class="vantivesMultiplier"
        :items="items"
        :min="min"
        :max="max"
        v-on:add-item="onAddItemEvent"
        v-on:remove-item="onRemoveItemEvent"
        :addBtnLabel="addBtnLabel"
    >
        <template v-slot:formrow="{ item, i }">
            <div class="formGroup formGroup--short">
                <select
                    class="formInput | formSelect | col-4"
                    :class="{ 'has-error': hasError(i, 'language') }"
                    :name="`contacts[${i}][language]`"
                    v-model="item.language"
                >
                    <option
                        v-for="(c, i) in parsedLanguages"
                        :key="i"
                        :value="c.value"
                    >{{ c.label }}</option>
                </select>
            </div>
            <div class="formGroup formGroup--regular">
                <input
                    class="formInput"
                    :class="{ 'has-error': hasError(i, 'email') }"
                    type="text"
                    :name="`contacts[${i}][email]`"
                    value=""
                    :placeholder="emailPlaceholder"
                    v-model="item.email"
                />
            </div>
        </template>
    </multiplier>
</template>



<script>

import Multiplier from './Multiplier.vue'

export default {

    /* Settings
    --------------------------------------------------------- */

    name: 'SupplierEmailsMultiplier',


    props: {
        emailPlaceholder: { type: String, required: true },
        langs: { type: String, required: true },
        min: { type: Number, default: 1 },
        max: { type: Number, default: 5 },
        addBtnLabel: { type: String, default: 'Add an email' },
        contacts: { type: Array, default: () => [{ language: 'fr', email: '' }] },
        errors: { type: Object, default: () => {} },
    },


    components: {
        Multiplier,
    },


    data() {
        return {
            items: this.contacts.length ? this.contacts : [{ language: 'fr', email: '' }],
        }
    },




    /* Data Handling
    --------------------------------------------------------- */

    computed: {
        parsedLanguages() {
            return JSON.parse(this.$props.langs)
        },
    },


    watch: {
        //
    },




    /* Methods
    --------------------------------------------------------- */

    methods: {
        onAddItemEvent() {
            this.$data.items.push({ language: 'fr', email: '' })
        },


        onRemoveItemEvent(e) {
            this.$data.items.splice(e.index, 1)
        },

        hasError(i, name) {
            return Object.prototype.hasOwnProperty.call(this.errors, `contacts.${i}.${name}`)
        },
    },

}

</script>
